import { useState } from "react";
import { Extent } from "ol/extent";

let cachedExtent: Extent | null = null;

function setCachedExtent(extent: Extent | null) {
  cachedExtent = extent;
}

function useCachedExtent(): [Extent | null, (extent: Extent | null) => void] {
  const [mountExtent] = useState(() => cachedExtent);
  return [mountExtent, setCachedExtent];
}

export default useCachedExtent;
